import { Pipe, PipeTransform } from '@angular/core';
import { getSkillColor } from 'src/app/utilities/skill-colors.utils';

@Pipe({
  name: 'skillColor',
  pure: true,
})
export class SkillColorPipe implements PipeTransform {
  transform(skillKey: string): string {
    return getSkillColor(skillKey);
  }
}
